<template>
    <div
        class="fixed right-0 bottom-36 w-[70px] py-3 bg-orange rounded-l-md leading-tight text-white font-bold text-center z-[800] cursor-pointer"
        tabindex="0"
        role="button"
        aria-label="Open help modal"
        aria-haspopup="dialog"
        :aria-expanded="mainStore.displayAdditionalAssistanceModal"
        @click="showAdditionalAssistanceModal"
        @keydown.enter.prevent="showAdditionalAssistanceModal"
        @keydown.space.prevent="showAdditionalAssistanceModal"
    >
        Need<br/>
        Help?
    </div>
</template>

<script lang="ts" setup>
import { useMainStore } from '@/stores/main';

const mainStore = useMainStore();

const showAdditionalAssistanceModal = () => {
    mainStore.displayAdditionalAssistanceModal = true;
}
</script>
